var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiceFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2FDA7B;}\n\t.st1{fill:#F0F0F0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_5378832_bet_casino_dice_gam321ble_gambling_icon",
    transform: "translate(-143.476 -143.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_526",
    className: "st0",
    d: "M145.8,143.7h21.3c1.2,0,2.1,1,2.1,2.1v21.3c0,1.2-1,2.1-2.1,2.1h-21.3 c-1.2,0-2.1-1-2.1-2.1v-21.3C143.7,144.6,144.6,143.7,145.8,143.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,4.3c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1S20.5,4.3,18.8,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.1,10c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1C16.2,11.4,14.8,10,13.1,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,15.7c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1C10.5,17.1,9.1,15.7,7.4,15.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceFilled);
export default __webpack_public_path__ + "static/media/Dice-filled.bbaeac69d58423e257c6bda72fb07d5a.svg";
export { ForwardRef as ReactComponent };